module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMobile) ? _c('div', {
    attrs: {
      "id": "landscape-warning"
    }
  }, [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$t('landscape')))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/landscape/icon.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3202e776"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landscape-warning/LandscapeWarning.vue
// module id = 257
// module chunks = 1